import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_OWNER_STATUS_ACTION_TYPE } from '../actions/ownerStatus.actions';

// Safe default — NOT owner. Until the owner-status endpoint resolves (it 404s
// until #895 deploys) everyone is treated as a non-owner, which hides the
// sensitive EARNED pillar + comp-plan chip. That is intentional defense-in-depth.
const initialState = { isOwner: false, ownershipPercentage: null };

const ownerStatusReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_OWNER_STATUS_ACTION_TYPE.SET_OWNER_STATUS:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default ownerStatusReducer;
